module.exports = __webpack_public_path__ + "static/media/blue-lagoon.0cf21f95.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/blue-lagoon.png
 ** module id = 180
 ** module chunks = 0
 **/